<template>
  <div class="event-row">
    <!-- column 1: image -->
    <div class="logo-wrap">
      <img src="/assets/images/example1.png" alt="Logo" class="logo" />
    </div>


    <span class="svg-icon-event-blue">
      <inline-svg src="/assets/svg/plus-square.svg"></inline-svg>
    </span>

    <span class="svg-icon-event-blue">
      <inline-svg src="/assets/svg/minus-square.svg"></inline-svg>
    </span>


    <!-- column 2: main text -->
    <div class="event-body">
      <span class="card-subheader">Vandring</span>
      <h3 class="event-name">Namn på event</h3>
      <h4 class="event-subheader">Huddinge</h4>
    </div>

    <!-- column 3: price + date -->
    <div class="meta">
      <p class="price">50 kr</p>
      <p class="date">23 Nov 2024</p>
    </div>

    <!-- column 4: CTA -->
    <div class="cta">
      <memlist-button @click="goto_event" variant="primary">Boka nu</memlist-button>
    </div>
  </div>
</template>


<script>
import messageParent from '@/core/services/messageParent';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: 'NewPublicEventListRowItem',
  components: {
    
  },
  props: ['item'],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember'])
  },
  async mounted() {
  
  },
  data() {
    return {

    };
  },
  watch: {
  
  },
  methods: {
    goto_event() {
      this.$router.push(`/public-event-details/${this.item.event_id}`);
    }
    
  }
};
</script>
<style scoped>

/* ─── row container ─── */
.event-row {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 4px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e9ecef;     /* optional divider */
}

/* ─── column 1: image ─── */
.logo-wrap {
  flex: 0 0 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
}
.logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ─── column 2: text block ─── */
.event-body {
  flex: 1 1 0;
  min-width: 0;
}

.card-subheader {
  font-size: 0.75rem;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #b85504;
}
.event-name       { margin:.25rem 0; font-size:1.25rem; font-weight:600; }
.event-subheader  { margin:0 0 .5rem; font-size:1rem;  color:#495057;    }

/* ─── column 3: price & date ─── */
.meta {
  flex: 0 0 100px;                /* adjust width as needed */
  text-align: right;
}
.price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f8a70;
  margin: 0;
}
.date  {
  font-size: 1.0rem;
  color: #6c757d;
  margin: .25rem 0 0;
}

/* ─── column 4: CTA button ─── */
.cta {
  flex: 0 0 auto;
  margin-left: auto;              /* pushes CTA to far right */
}
.cta memlist-button {
  min-width: 120px;
}

/* ─── mobile stacking ─── */
@media (max-width: 576px) {
  .event-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .logo-wrap,
  .cta memlist-button {
    width: 100%;
    height: 180px;                /* taller hero on phones   */
  }

  .meta {
    text-align: left;
    flex: 0 0 auto;
  }

  .cta {
    margin-left: 0;
  }
}


</style>